import React, { useEffect, useState, useRef, useContext } from "react";
import SellerSidebar from "../../navigation/sellerNavigation";
import { getData } from "../../fetchRoutes/getData";
import BarChart from "./charts/barChart";
import WordCloudChart from "./charts/wordCloudChart";
import PieChart from "./charts/pieChart";
import ScatterChart from "./charts/scatterChart";
import PaymentsOverTimeChart from "./charts/paymentsOverTimeChart";
import TopRevenueAuctionsChart from "./charts/topRevenueAuctionsChart";
import PaymentStatusPieChart from "./charts/paymentsStatusPieChart";
import SellerMobileSidebar from "../../navigation/sellerMobileNavigation";
import { DeviceContext } from "../../context/deviceContext";

export default function AdminDashboardContainer() {

  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [showLazyCharts, setShowLazyCharts] = useState(false);
  const loaderRef = useRef(null);
  const adminAnalyticsUrl = process.env.REACT_APP_ADMIN_ANALYTICS;

  const {isMobile}= useContext(DeviceContext);
  

  // Fetch dashboard analytics
  useEffect(() => {
    const fetchAnalytics = async () => {
      setLoading(true);
      try {
        const response = await getData(adminAnalyticsUrl);
        if (response.status === "success") {
          setAnalytics(response.data);
        } else {
          setError("Failed to fetch data");
        }
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, [adminAnalyticsUrl]);

  // Lazy-load charts when loader is in view
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setShowLazyCharts(true);
        }
      },
      { threshold: 1.0 }
    );
  
    const currentLoader = loaderRef.current;
  
    if (currentLoader) observer.observe(currentLoader);
  
    return () => {
      if (currentLoader) observer.unobserve(currentLoader);
    };
  }, []);
  

  return (
    <div className="sellerDashboard">
      {isMobile ? <SellerMobileSidebar/> :<SellerSidebar />}
      <div className="container moreProperties">
        <h1 className="containerTitle">MY DASHBOARD</h1>

        {loading && (
          <div className="loaderContainer">
            <div className="loader"></div>
            <p className="loadingText">Loading data...</p>
          </div>
        )}

        {error && <p style={{ color: "red" }}>{error}</p>}

        {analytics && (
          <div className="chartGrid">
            {/* First four charts */}
            <BarChart data={analytics.topProperties} />
            <TopRevenueAuctionsChart data={analytics.payments.topAuctions} />
            <PaymentsOverTimeChart data={analytics.payments.overTime} />
            <ScatterChart data={analytics.bidsOverTime} />

            {/* Lazy charts will mount when loaderRef comes into view */}
            {showLazyCharts && (
              <>
                <PieChart data={analytics.auctionStatus} />
                <PaymentStatusPieChart data={analytics.payments.statusDistribution} />
                <WordCloudChart data={analytics.wordCloud} />
                
              </>
            )}
          </div>
        )}

        {/* Lazy loader trigger */}
        {!showLazyCharts && <div ref={loaderRef} style={{ height: "40px" }} />}
      </div>
    </div>
  );
}
